// extracted by mini-css-extract-plugin
export default {"wrap":"FullPageLoading_wrap__43SYo","label":"FullPageLoading_label__Qhe5R"};